import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[hrSlide]',
})
export class SlideDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
